import { useSyncExternalStore } from 'react'
import { parseSvidQuery, type SvidQuery } from '../utils/svidQuery'

// stable snapshot when `SVID` is absent (must reuse reference for `useSyncExternalStore`)
const SVID_QUERY_EMPTY: SvidQuery = { isPresent: false, value: '' }

let cachedSearch = ''
let cachedSvidQuery: SvidQuery = SVID_QUERY_EMPTY

function subscribe(onChange: () => void) {
    window.addEventListener('popstate', onChange)
    window.addEventListener('hashchange', onChange)
    return () => {
        window.removeEventListener('popstate', onChange)
        window.removeEventListener('hashchange', onChange)
    }
}

function getSnapshot(): SvidQuery {
    const search = window.location.search
    if (search === cachedSearch) {
        return cachedSvidQuery
    }
    cachedSearch = search
    const next = parseSvidQuery(search)
    cachedSvidQuery =
        !next.isPresent && next.value === ''
            ? SVID_QUERY_EMPTY
            : { isPresent: next.isPresent, value: next.value }
    return cachedSvidQuery
}

function getServerSnapshot(): SvidQuery {
    return SVID_QUERY_EMPTY
}

// reads `SVID` from the current URL and re-renders on navigation
export function useSvidQuery(): SvidQuery {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
